
import config from './config'
class CentralControl {
    constructor() {
        for (var a = 0; a < config.length; a++) {
            this[config[a].key] = config[a].value;
        }
        console.log("本地配置加载成功!")
    }
}
let centralControl = new CentralControl();
export default centralControl;